import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { useAuth } from '../context/AuthContext';

const RootLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser, canAccess, getDefaultPage } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!currentUser) {
      navigate('/login', { replace: true });
    }
  }, [currentUser, navigate]);

  // Redirect if user doesn't have access to current page
  useEffect(() => {
    if (currentUser && !canAccess(location.pathname)) {
      navigate(getDefaultPage(), { replace: true });
    }
  }, [currentUser, location.pathname, canAccess, navigate, getDefaultPage]);

  const openSidebar = () => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeSidebar = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Don't render content if not authenticated
  if (!currentUser) {
    return null;
  }

  return (
    <>
      <div className="grid grid-cols-[260px_1fr] max-1024:grid-cols-[210px_1fr] max-768:grid-cols-[1fr] grid-rows-[auto_1fr] min-h-screen pr-2.5 max-768:pl-2.5 bg-[#EDEDF2] font-figtree text-sm">
        <Header openSidebar={openSidebar} />
        <Sidebar isOpen={isOpen} closeSidebar={closeSidebar} />
        <main className="col-start-2 max-768:col-start-1 bg-[#F9F9FC] border-t-[2px] border-t-[#EEF2F7]">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default RootLayout;
